import React from 'react';

const PremiumIcon = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="m14.02 13.417 2.667-1.667v8.667"
      stroke="url(#a)"
      strokeWidth={1.33}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.427 13.116a4.27 4.27 0 0 1-.018 6.035l-.07.067a4.268 4.268 0 0 1-3.035 5.216l-.087.022a4.267 4.267 0 0 1-5.235 3l-.093-.027a4.266 4.266 0 0 1-6.035-.01l-.077-.078a4.267 4.267 0 0 1-5.208-3.045l-.02-.082a4.267 4.267 0 0 1-3-5.235c0-.031.018-.063.026-.095a4.268 4.268 0 0 1 .019-6.033l.07-.069a4.267 4.267 0 0 1 3.033-5.215l.087-.021a4.267 4.267 0 0 1 5.237-3l.085.023a4.265 4.265 0 0 1 6.033.018l.068.07a4.267 4.267 0 0 1 5.239 3.129 4.267 4.267 0 0 1 3 5.235c-.009.031-.019.061-.027.093l.008.002Z"
      stroke="url(#b)"
      strokeWidth={1.33}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.045 24.908a8.825 8.825 0 1 0 0-17.65 8.825 8.825 0 0 0 0 17.65Z"
      stroke="url(#c)"
      strokeWidth={1.33}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <radialGradient
        id="a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-107.031 17.067 4.926) scale(13.3064 25.3535)"
      >
        <stop stopColor="#E60000" />
        <stop offset={1} stopColor="#9C2AA0" />
      </radialGradient>
      <radialGradient
        id="b"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-37.02156 -37.20942 126.57799 -125.93893 35.025 35.316)"
      >
        <stop stopColor="#E60000" />
        <stop offset={1} stopColor="#9C2AA0" />
      </radialGradient>
      <radialGradient
        id="c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-134.873 20.786 8.679) scale(36.562 124.376)"
      >
        <stop stopColor="#E60000" />
        <stop offset={1} stopColor="#9C2AA0" />
      </radialGradient>
    </defs>
  </svg>

  )
}

export default PremiumIcon;